module.exports = __webpack_public_path__ + "img/new-step11.2389e5d4.jpg";